import withPreference from 'hoc/withPreferences';
import React from 'react';
import { Link } from 'react-router-dom';
import TermYearList from 'components/term_year/TermYearList';
import withCards from '../../hoc/withCards';
import { fetchTermsYears } from 'services/academic';

const TermYearListPage = ({ ...props }) => {
  return (
    <>
      <div className="mb-3">
        <Link className="btn btn-primary" to={`/etapas/anos/new`}>
          CADASTRAR ETAPA x ANO
        </Link>
      </div>
      <TermYearList {...props} />
    </>
  );
};

export default withCards({
  fetch: fetchTermsYears,
  title: 'Lista de Etapas x Ano',
  paginated: true,
  noResultsText: 'Nenhuma Etapa x Ano foi encontrada.',
})(withPreference(TermYearListPage));
